import { useContext }  from 'react';
import './PageSituationStrategie.css';
import { StepContext } from '../../contexts/StepContext';
import { SlidesContext } from '../../contexts/SlidesContext';
import ReviewFormattedMessage from '../../generics/ReviewFormattedMessage';

export default function PageSituationStrategie ( {slide} ) {
  const { slidesAnswers, updateValues } = useContext(SlidesContext);
  //const { activeValue, setActiveValue } = useState(null);

    const handleChange = (event) => {
      const value = parseInt(event.target.value, 10);
      updateValues(slide.inputNumber, slide.key, value);
  }
  
   /*const _changeLabel = () => {
    if (slidesAnswers[slide[step].inputNumber][slide[step].key] === -100){
        return slide[step].labelLvl[0].label1;
    }
    else if((slidesAnswers[slide[step].inputNumber][slide[step].key] === -60)){
        return slide[step].labelLvl[0].label2;
    }
    else if((slidesAnswers[slide[step].inputNumber][slide[step].key] === -20)){
        return slide[step].labelLvl[0].label3;
    }
    else if((slidesAnswers[slide[step].inputNumber][slide[step].key] === 20)){
        return slide[step].labelLvl[0].label4;
    }
    else if((slidesAnswers[slide[step].inputNumber][slide[step].key] === 60)){
        return slide[step].labelLvl[0].label5;
    }
    else if((slidesAnswers[slide[step].inputNumber][slide[step].key] === 100)){
        return slide[step].labelLvl[0].label6;
    }
    else {
        return null;
    }
  }
  const checkIfChecked = (a,b) => {
      console.log("a"+ a)
      console.log("b"+ b)
    }
  */
    return (
      <div className="PageSituationStrategie animate__animated animate__fadeInRight">
        <div className="PageSituationStrategie-boxes">
          <div className="PageSituationStrategie-box box-situation">
              <h2><ReviewFormattedMessage descriptor={slide.situationTitle} /></h2>
              <p>
                <ReviewFormattedMessage descriptor={slide.situationText} />
              </p>
          </div>
          <div className="PageSituationStrategie-box box-strategy">
            <h2><ReviewFormattedMessage descriptor={slide.strategyTitle} /></h2>
            <div className="strategy-texts">
              {
                Array.isArray(slide.strategyTexts) && slide.strategyTexts.map((strat, key) => (
                  <p key={key}><ReviewFormattedMessage descriptor={strat.strategyText}/></p>
                ))
              }
            </div>
        </div>
        </div>
        
        <div className="PageSituationStrategie-question">
          <h2><ReviewFormattedMessage descriptor={slide.question}/></h2>
        </div>
        <div className="PSS_slider">
          <span id="PSS_SL"><ReviewFormattedMessage descriptor={slide.labelLvl[0].label1} /></span>
          <div>
            <input className="PSS_hidden PSS_radio-label PSS_choice-button" type="radio" value="-100" id={slide.key+"-rb0"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === -100}  />
            <label className="PSS_button-label PSS_size0" htmlFor={slide.key+"-rb0"}>O</label>
          </div>
          <div>
            <input className="PSS_hidden PSS_radio-label PSS_choice-button" type="radio"  value="-60" id={slide.key+"-rb1"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === -60} />
            <label className="PSS_button-label PSS_size1" htmlFor={slide.key+"-rb1"} >O</label>
          </div>
          <div>
            <input className="PSS_hidden PSS_radio-label PSS_choice-button" type="radio"  value="-20" id={slide.key+"-rb2"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === -20} />
            <label className="PSS_button-label PSS_size2" htmlFor={slide.key+"-rb2"} >O</label>
          </div>
          <div>
            <input className="PSS_hidden PSS_radio-label PSS_choice-button" type="radio"  value="20" id={slide.key+"-rb3"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === 20} />
            <label className="PSS_button-label PSS_size3" htmlFor={slide.key+"-rb3"} >O</label>
          </div>
          <div>
            <input className="PSS_hidden PSS_radio-label PSS_choice-button" type="radio"  value="60" id={slide.key+"-rb4"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === 60} />
            <label className="PSS_button-label PSS_size4" htmlFor={slide.key+"-rb4"} >O</label>
          </div>
          <div>
            <input className="PSS_hidden PSS_radio-label PSS_choice-button" type="radio"  value="100" id={slide.key+"-rb5"} name={slide.key} onChange={handleChange} checked={slidesAnswers[slide.inputNumber][slide.key] === 100} />
            <label className="PSS_button-label PSS_size5" htmlFor={slide.key+"-rb5"} >O</label>
          </div>
          <span id="PSS_SR"><ReviewFormattedMessage descriptor={slide.labelLvl[0].label6} /></span>
        </div>
      </div>
    );
}
